const DELETE_SUPPLEMENTARY_FILE = (state, payload) => {
  for (let i = 0; i < state.submissionItem.supplementaryAssets.length; i++) {
    if (state.submissionItem.supplementaryAssets[i].id === payload) {
      state.submissionItem.supplementaryAssets[i].asset = undefined;
    }
  }
};

export default DELETE_SUPPLEMENTARY_FILE;
